import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconClose = (props) => /* @__PURE__ */ _jsx("svg", {
	className: "svg-close",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15.1.9c-.5-.5-1.2-.5-1.7 0L8 6.3 2.5.9C2 .4 1.3.4.8.9S.3 2.1.8 2.6L6.3 8 .8 13.5c-.5.5-.5 1.2 0 1.7.2.2.5.4.8.4.3 0 .6-.1.8-.4L8 9.7l5.5 5.5c.2.2.5.4.8.4.3 0 .6-.1.8-.4.5-.5.5-1.2 0-1.7L9.7 8l5.5-5.5c.4-.4.4-1.2-.1-1.6" })
});
export default SvgIconClose;
